const trimTrailingSlash = (value = "") => value.replace(/\/$/, "");

const explicitBackendUrl = trimTrailingSlash(process.env.REACT_APP_BACKEND_URL || "");
const browserOrigin = typeof window !== "undefined" ? window.location.origin : "";

export const BACKEND_ORIGIN = explicitBackendUrl || browserOrigin;
export const API_BASE = explicitBackendUrl ? `${explicitBackendUrl}/api` : "/api";
export const REFERRAL_ORIGIN = trimTrailingSlash(
  process.env.REACT_APP_PUBLIC_REFERRAL_URL || explicitBackendUrl || browserOrigin
);
